import { render, staticRenderFns } from "./SourceIcon.vue?vue&type=template&id=187a92af&scoped=true"
import script from "./SourceIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SourceIcon.vue?vue&type=style&index=0&id=187a92af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a92af",
  null
  
)

export default component.exports